import { define } from 'wicked-elements'
import Walkway from 'walkway.js'

define('[data-component~="splash"]', {
  init () {
    this.walkway = new Walkway({
      selector: '#gallery-weekend-splash',
      duration: '2000'
    })
  },
  connected () {
    this.walkway.draw()
    this.element.classList.add('walkway-init')
  },
  disconnected () {
    
  }
})